import React from 'react';

const brands = ['Samsung','Coca-Cola','Microsoft','Amazon','Google','Adidas'];

export default function Brands() {
  const items = [...brands, ...brands];
  return (
    <section id="brands" className="section-sm bg-dark">
      <div className="max-w-content mx-auto text-center mb-12 reveal">
        <span className="label label-red">Collaboration</span>
        <h2 className="heading mt-5">Brand <em>Partners</em></h2>
        <div className="divider center wide mt-5" />
      </div>

      <div className="marquee-wrap">
        <div className="marquee-track" style={{ animationDirection:'reverse', animationDuration:'22s' }}>
          {items.map((name, i) => (
            <div key={i}
              className="flex items-center justify-center mx-5 px-10 py-5 rounded-2xl shrink-0"
              style={{ background:'rgba(255,255,255,.04)', border:'1px solid rgba(255,255,255,.08)', minWidth:'160px' }}>
              <span className="text-white font-black text-sm tracking-widest uppercase">{name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
